import { formatNumber, hexToRgba, nearestInteger } from '../../../../../apps/frontend/src/utils/utilFunctions';

const StatCell = ({ color = 'orange', top = 0, bottom = 0, showPercentage, textAppend = '', themedText = false }) => {
  const percentage = (top / bottom) * 100;

  const getPercentage = () => {
    if (isNaN(percentage)) return '0%';
    return nearestInteger(formatNumber(percentage)) + '%';
  };

  const themedTextColor = 'text-[var(--q3-neutral-light)]';

  const backgroundBarStyle = {
    width: `${percentage > 0 ? percentage : 0}%`,
    background: `linear-gradient(270deg, ${hexToRgba(color, 0.15)} 0%, ${hexToRgba(color, 0)} 100%)`,
    borderRight: `2px solid ${color}`,
    transition: 'all 0.5s ease-in-out',
  };

  return (
    <div className="relative w-full h-full py-5 px-4 overflow-hidden">
      {/* Background bar */}
      <div className="absolute top-0 left-0 h-full z-0" style={backgroundBarStyle}></div>
      <div className="relative z-1 flex items-center gap-1 text-xs font-medium">
        {showPercentage ? (
          <span
            className={`text-lg font-medium text-[var(--q3-neutral-default)] ${!themedText ? '' : themedTextColor}`}
          >
            {getPercentage()}
          </span>
        ) : (
          <>
            {bottom === 0 ? (
              <span className="text-lg font-bold text-[var(--q3-neutral-default)]">{formatNumber(top)}</span>
            ) : (
              <>
                <span className="text-lg font-bold text-[var(--q3-neutral-default)]">{nearestInteger(top)}</span>
                <span className="text-xs text-[var(--q3-neutral-light)]">/ {bottom}</span>
              </>
            )}
            {textAppend && <span className="text-xs text-[var(--q3-neutral-light)]">{textAppend}</span>}
          </>
        )}
      </div>
    </div>
  );
};

export default StatCell;
